(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/pay-after-deposit-dialog.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/pay-after-deposit-dialog.js');

'use strict';

const {
  Currency: formatCurrency
} = svs.utils.format;
function payAfterDepositDialog(_ref) {
  let {
    cancel,
    balance,
    product,
    price,
    saveState
  } = _ref;
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    type: svs.ui.dialog.type.INFO,
    icon: 'deposit',
    title: 'Du behöver sätta in pengar för att spela på din Lyckoplats',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: "Saldo: ".concat(formatCurrency(balance), " kr"),
      align: svs.ui.dialog.message.align.CENTER
    }, {
      type: svs.ui.dialog.message.TEXT,
      text: "Pris: ".concat(formatCurrency(price), " kr"),
      align: svs.ui.dialog.message.align.CENTER
    }],
    actions: [{
      title: 'Avbryt',
      callback: (e, forms, dialog) => {
        dialog.close();
        cancel();
      }
    }, {
      title: 'Sätt in och betala',
      callback: (e, forms, dialog) => {
        dialog.close(() => {
          saveState(() => svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
            returnUrl: window.location.href,
            product,
            price
          }));
        });
      }
    }]
  }));
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  payAfterDepositDialog
});

 })(window);